module.exports = __webpack_public_path__ + "static/practice-mgmt-cba5defa9d6856db9e22fa31aaccee1e.svg";